import React from 'react';
import * as S from './styles';

function Video() {
  return (
    <S.Wrapper>
      <S.Title>E assim foi o ACE 2019, o K20!</S.Title>
      <S.Container>
        <iframe
          title="ACE 2019"
          src="https://player.vimeo.com/video/393195207"
          width="100%"
          height="100%"
          frameBorder="0"
          allow="autoplay;
          fullscreen"
          allowFullScreen
        />
      </S.Container>
    </S.Wrapper>
  );
}

export default Video;
